import { marked } from 'marked'

const scriptRegex = /<script|(\Won\w+)=|javascript:|src=/

export const Markdown = {
  beforeMount (el, bindings, vnode) {
    mkdStringToHtml(el, bindings)
  },
  updated (el, bindings) {
    mkdStringToHtml(el, bindings)
  }
}
const mkdStringToHtml = (el, bindings) => {
  const val = bindings.value || ''
  if (scriptRegex.test(val) && !bindings.arg?.includes('unsafe')) {
    return el
  }
  const mkdString = marked.parse(val)
  el.innerHTML = `<div class="fluency-markdown">${mkdString}</div>`
  return el
}

export const MarkdownPlugin = {
  install (Vue, options) {
    Vue.directive('markdown', Markdown)
  }
}
